import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'parentFidelitySummary',
    label: 'Parent Fidelity Summary',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
